import React from 'react';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';
import f from 'modules/RestAPIFetch';
import useRsaKey from './useRsaKey';
const excepts = [
];
const requisite = [
];
export default function useQueueRequest(host, actions) {
  const [queue, setQueue] = Recoil.useRecoilState(AppStore.communication.queues(host));
  const [access_token, setAccessToken] = React.useState(null);
  // const onRenewRequest = useFetch(host, 'refresh', { rewind: 1, urgency: true });
  const processingRef = React.useRef({});

  const {
    requestRsaKey,
  } = useRsaKey();

  const {
    onRenewRequest,
    onTokenInvalid,
    onTokenExpired,
  } = actions || {};

  React.useEffect(() => {
    if (window.NB_COMMUNICATION_LOG) console.log(host, 'QUEUE.length', queue.length, queue.map(({ id }) => id));
    const request = queue[0];
    if (!request) return;
    if (processingRef.current[host]) return;
    const {
      id,
      headers,
      parameters,
      timeout,
      events = {},
      timestamp,
      options = {},
      urgency,
      uuid,
    } = request;
    if (window.NB_COMMUNICATION_LOG) console.log(host, 'QUEUE', id, uuid);
    const onReceive = (res) => {
      switch (+res.res_code) {
        // case Constants.RES_CODE_TOKEN_INVALID: {
        //   setQueue(() => []);
        //   onTokenInvalid && onTokenInvalid();
        //   break;
        // }
        // case Constants.RES_CODE_TOKEN_EXPIRED: {
        //   const onReceive = (res) => {
        //     if (+res.res_code === 200) {
        //       const {
        //         access_token
        //       } = res.data;
        //       setAccessToken(() => access_token);
        //       setQueue((qs) => [...qs]);
        //       onTokenExpired && onTokenExpired(access_token);
        //     } else {
        //       setQueue(() => []);
        //       onTokenInvalid && onTokenInvalid();
        //     }
        //   };
        //   processingRef.current = false;
        //   onRenewRequest({
        //     timeout: 30000,
        //     events: {
        //       onReceive,
        //       onCatch,
        //     },
        //   })
        //   break;
        // }
        default: {
          setQueue(([_, ...qs]) => qs);
          events.onReceive && events.onReceive(res);
          break;
        }
      }
    };
    const onCatch = (err) => {
      if (window.NB_COMMUNICATION_LOG) console.log(host, 'UNLOCK', id, uuid);
      processingRef.current[host] = false;
      events.onCatch && events.onCatch(err);
      setQueue(([q, ...qs]) => {
        let { rewind = 0 } = q || {};
        while (0 <= --rewind) {
          qs.shift();
        }
        return [...qs];
      });
    };
    const onExpire = (abort) => {
      if (window.NB_COMMUNICATION_LOG) console.log(host, 'UNLOCK', id, uuid);
      processingRef.current[host] = false;
      return events.onExpire && events.onExpire(abort);
    };
    const onStart = () => {
      if (window.NB_COMMUNICATION_LOG) console.log(host, 'LOCK', id, uuid);
      processingRef.current[host] = true;
      events.onStart && events.onStart();
    };
    const onEnd = () => {
      if (window.NB_COMMUNICATION_LOG) console.log(host, 'UNLOCK', id, uuid);
      processingRef.current[host] = false;
      events.onEnd && events.onEnd();
    };

    if (excepts.includes(id) || !requisite.includes(id)) {
      f(id, host, {
        headers,
        parameters,
      }, {
        ...options,
        timeout,
        // access_token,
        timestamp,
      }, {
        onReceive,
        onCatch,
        onExpire,
        onStart,
        onEnd,
      });
    } else {
      setQueue(qs => qs.filter(q => q.uuid !== uuid));
      requestRsaKey(id, uuid, (success, data) => {
        if (success) {
          f(id, host, {
            headers,
            parameters,
            uuid,
          }, {
            ...options,
            timeout,
            access_token,
            timestamp,
            secure: data,
          }, {
            onReceive,
            onCatch,
            onExpire,
            onStart,
            onEnd,
          });
        } else {
          const {
            type,
            extra,
          } = data;
          events[type] && events[type](extra);
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queue]);
}